export enum SafeStringType {
    Html = 'html',
    Style = 'style',
    Script = 'script',
    Url = 'url',
    ResourceUrl = 'resourceUrl'
}
